import { useMemo } from "react";
import { useSitePageMetadata } from "@/react/routes/Main/useSitePageMetadata";

export const useAddCustomProperties = () => {
  const { isSitePageRoute, sitePageId, sitePageSlug } = useSitePageMetadata();

  return useMemo(() => {
    const sitePageProps = isSitePageRoute
      ? { site_page_id: sitePageId, site_page_slug: sitePageSlug }
      : {};

    return {
      ...sitePageProps,
    };
  }, [isSitePageRoute, sitePageId, sitePageSlug]);
};
